import {
  AlertStatusName,
  statusDisplayNameForTrackings,
} from '@rsos/constants/alertStatuses';
import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

const ALERT_CHAT_BOX_EVENT_NAMES = {
  SEND_DATA_SUPPLEMENTAL: 'click_send_data_supplemental_alert',
  CLICK_BUTTON: 'click_alert_button',
  CLICK_BUTTON_TIMESTAMPED: 'click_alert_button_timestamped',
};

interface TrackAlertChatButtonClickParams {
  buttonText: AlertStatusName;
  isSupplemental?: boolean;
  selectedAlertID: string | undefined;
  irpVersion: string | undefined;
}

export const trackAlertChatButtonClick = ({
  buttonText,
  isSupplemental = false,
  selectedAlertID,
  irpVersion,
}: TrackAlertChatButtonClickParams): void => {
  if (isSupplemental) {
    gspx.trackEvent({
      name: ALERT_CHAT_BOX_EVENT_NAMES.SEND_DATA_SUPPLEMENTAL,
      type: GPX_EVENT_TYPES.INFO,
      feature: GPX_FEATURES.LEGACY,
      capability: GPX_CAPABILITIES.LEGACY,
      route: GPX_ROUTES.CALL_QUEUE,
      additionalKeys: {
        legacy_category: 'Alert',
        legacy_name: 'Click Send Data in RSP for supplemental alert',
        Category: 'Alert',
        'Launched date': new Date(),
        irpVersion,
      },
      entities: {
        alert_id: selectedAlertID,
      },
    });
  } else {
    const displayStatus = statusDisplayNameForTrackings[buttonText];

    // TODO: To confirm if one of the custom events can be removed.
    gspx.trackEvent({
      name: ALERT_CHAT_BOX_EVENT_NAMES.CLICK_BUTTON,
      type: GPX_EVENT_TYPES.INFO,
      feature: GPX_FEATURES.LEGACY,
      capability: GPX_CAPABILITIES.LEGACY,
      route: GPX_ROUTES.CALL_QUEUE,
      additionalKeys: {
        legacy_category: 'Alert',
        legacy_name: `Click ${displayStatus} button in RSP`,
        Category: 'Alert',
        'Launched date': new Date(),
        irpVersion,
      },
      entities: {
        alert_id: selectedAlertID,
      },
    });

    gspx.trackEvent({
      name: ALERT_CHAT_BOX_EVENT_NAMES.CLICK_BUTTON_TIMESTAMPED,
      type: GPX_EVENT_TYPES.INFO,
      feature: GPX_FEATURES.LEGACY,
      capability: GPX_CAPABILITIES.LEGACY,
      route: GPX_ROUTES.CALL_QUEUE,
      additionalKeys: {
        legacy_category: 'Alert',
        legacy_name: `Click ${displayStatus} button in RSP at ${new Date()}`,
        Category: 'Alert',
        'Launched date': new Date(),
        irpVersion,
      },
      entities: {
        alert_id: selectedAlertID,
      },
    });
  }
};
